const EXCLUDED_STATUS_TOKENS = new Set(['optedout', 'cancelled', 'canceled']);

export const normalizeStatusToken = (value) => {
  if (value === null || value === undefined) return '';
  return String(value)
    .trim()
    .toUpperCase()
    .replace(/[^A-Z]/g, '');
};

export const getFilteredSnapshotEnrollmentCount = (snapshot = {}) => {
  const totalEnrollmentCount = Number(snapshot?.enrollmentCount);
  const statusCounts = snapshot?.statusCounts && typeof snapshot.statusCounts === 'object' ? snapshot.statusCounts : {};

  if (!Number.isFinite(totalEnrollmentCount)) {
    return null;
  }

  const excludedCount = Object.entries(statusCounts).reduce((sum, [status, count]) => {
    const normalized = normalizeStatusToken(status).toLowerCase();
    if (!EXCLUDED_STATUS_TOKENS.has(normalized)) return sum;
    const parsedCount = Number(count);
    return sum + (Number.isFinite(parsedCount) ? parsedCount : 0);
  }, 0);

  return Math.max(totalEnrollmentCount - excludedCount, 0);
};
